const MINI_CART_ITEMS = $(".mini-cart-items");
const MINI_CART_PANEL = $(".cart-panel");

$(function () {

    /* flatpickr */
    $(".flatpickr").flatpickr({
        "dateFormat": "d-m-Y",
        // "disable": [
        //     function(date) {
        //         return (date.getDay() === 0);
        //     }
        // ],
        "locale": {
            "firstDayOfWeek": 1
        },
        onChange: function(selectedDates, dateStr, instance) {
            let str = selectedDates.toString();
            if(str.substr(0,3) === "Sat") {
                $("#time").val('');
                $(".disable-saturday").attr('disabled', true);
            } else {
                $(".disable-saturday").attr('disabled', false);
            }
        }
    });

    /* autopopulate fields */
    if ($(".populate").length > 0) {

        let inputFields = [
            'company',
            'street',
            'house_no',
            'zipcode',
            'city',
            'country',
        ];
        $(".populate").on('click', function () {
            let item = $(this);
            let fieldType = $(this).data('type');
            $.each(inputFields, function (key, value) {
                $("#" + fieldType + "_" + value).val(item.data(value));
            });
            parent.$.fancybox.close();
        });
    }

    /* toggle shipping address */
    if ($('.toggle-shipping-address').length > 0) {

        $('.toggle-shipping-address').on('change', function () {
            if ($(this).is(':checked')) {
                $('#shipping-address-container').show();
            } else {
                $('#shipping-address-container').hide();
            }
        })
    }

    /* Sized */
    $("#size-id").change(function() {
        let sizeId = $("#size-id").val();

        let salePrice = $(".sale-price");
        let currentPrice = $(".current-price");
        let defaultPrice = $(".main-default-price");


        $.ajax({
            url: 'ajax/size-update-price',
            data: { sizeId: sizeId },
            success: function (feedback) {
                currentPrice.html('');
                salePrice.html('');
                defaultPrice.html('');

                if (feedback.hasOwnProperty('price') && feedback.price !== '') {
                    currentPrice.html(feedback.price);
                    salePrice.html(feedback.salePrice);
                } else {
                    defaultPrice.html(feedback.salePrice);
                }
            }
        });
    });
    $("#size-id").trigger('change');

    /* Sized Quick add */
    $(".quick-size-select").change(function() {
        let sizeId = $(this).val();
        let salePrice = $(this).closest('.cart-quick-add-product').find(".quick-sale-price");
        let currentPrice = $(this).closest('.cart-quick-add-product').find(".quick-current-price");
        let defaultPrice = $(this).closest('.cart-quick-add-product').find(".default-price");

        $.ajax({
            url: 'ajax/size-update-price',
            data: { sizeId: sizeId },
            success: function (feedback) {
                currentPrice.html('');
                salePrice.html('');
                defaultPrice.html('');

                if (feedback.hasOwnProperty('price') && feedback.price !== '') {
                    currentPrice.html(feedback.price);
                    salePrice.html(feedback.salePrice);
                } else {
                    defaultPrice.html(feedback.salePrice);
                }

            }
        });
    });
    $(".quick-size-select").trigger('change');


    /* add product to cart session */
    $("body").on('click', ".cart-add-product .btn-product-add", function (e) {
        e.preventDefault();

        let productId = $(this).closest('.cart-add-product').find("input[name='product']").val();
        let sizeId  = $("#size-id").val();
        let quantity = $(this).closest('.cart-add-product').find("input[name='quantity']").val();
        let btn = $(this).closest('.cart-add-product').find(".submit");
        let discountCode = $("#discount-code").val();

        addProductToCart(productId, quantity, btn, '', sizeId, discountCode);
    });


    /* Quick add product to cart session */
    $("body").on('click', ".cart-quick-add-product .quick-product-add", function (e) {
        e.preventDefault();

        let productId = $(this).data("product");
        let sizeId  = $(this).closest('.cart-quick-add-product').find("select[name='size']").val();
        let quantity = 1;
        let btn = $(this);

        addProductToCart(productId, quantity, btn, '', sizeId);
    });


    $("body").on('click', ".cart-add-product-btn", function (e) {
        e.preventDefault();

        let reload = $(this).data("reload");
        let productId = $(this).data("product");
        let quantity = 1;
        let btn = $(this);

        addProductToCart(productId, quantity, btn, reload);

    });
    $("body").on('click', ".cart-add-give-away", function (e) {

        let productId = $(this).data("product");
        let add = $(this).is(":checked");

        addGiveAwayToCart(productId, add);

    });

    $("body").on('click', ".cart-add-service", function (e) {

        let serviceId = $(this).data("service");
        let add = $(this).is(":checked");
        let customerMessage = null;

        addServiceToCart(serviceId, add, customerMessage);

    });

    $("body").on('blur', ".customer-message", function (e) {
        let customerMessage = $(".customer-message").val();
        if (customerMessage.length > 0) {
            $(".cart-add-service-packing-service").trigger('click');
            $(".service-packing-service").addClass('active');
        }
        addServiceToCart(null, null, customerMessage);
    });


    $("body").on('click', ".cart-row-quantity-update", function(e) {
        e.preventDefault();

        let productId = $(this).data('product');
        let action = $(this).data('action');
        let target = $("#input-quantity-"+productId);
        let orderBtn = $(this).closest(".product-row").find(".cart-order-btn");
        let quantity = parseInt(target.val());

        // update quantity
        switch(action) {
            case 'plus':
                quantity = (quantity+1);
                break;
            case 'min':
                quantity = (quantity-1);
                break;
            case 'remove':
                quantity = 0;
                break;
            default:
                break;
        }

        // prevent negative quantity
        if (quantity<0) {
            quantity = 0;
        }

        // update input
        target.val(quantity);
        target.trigger('change');

        // enable cart-order-btn
        if (quantity>0) {
            orderBtn.css('visibility', 'visible');
        } else {
            orderBtn.css('visibility', 'hidden');
        }
    });


    $("body").on('change', ".cart-row-quantity", function(e) {

        disableCart();

        let productId = $(this).data('product');
        let quantity = parseInt($(this).val());
        let row = $(this).closest(".product-row");
        let isCart = 0;

        if (row.length>0) {
            // toggle productrow active state
            if (quantity>0) {
                row.addClass('active');
            } else {
                row.removeClass('active');
            }
        } else {
            // set as cartrow
            isCart = 1;
        }

        // call update script
        $.ajax({
            url: 'ajax/cart-update-row',
            data: {product: productId, quantity: quantity, isCart: isCart},
            success: function (feedback) {

                // update cart
                if (feedback.hasOwnProperty('cart')) {
                    $("#cart").html(feedback.cart);
                }

                // update mini-cart in header
                if (feedback.hasOwnProperty('success') && feedback.success) {
                    updateMiniCart();
                } else {
                    alert("ERROR: cannot update product");
                }
                enableCart();
            }
        });
    });

    // handle sorting selectbox
    let sortSelectBox = $("select[name='sort']");
    if (sortSelectBox.length > 0) {
        sortSelectBox.on('change', function () {
            let params = $(this).val().split('&');
            let UrlParams = '';
            for (let i = 0, len = params.length; i < len; i++) {
                let x = params[i].split('=');
                let key = encodeURI(x[0]);
                let value = encodeURI(x[1]);
                UrlParams = rebuildUrlParameters(key, value, UrlParams)
            }
            insertUrlParameters(UrlParams);
        });
    }

    // handle product filter checkboxes
    let filterItems = $(".filter-items");
    if (filterItems.length > 0) {
        filterItems.on('change', function () {

            let properties = [];
            $.each($(".filter-items:checked"), function () {
                properties.push($(this).val());
            });

            let UrlParams = rebuildUrlParameters('prop', properties.join(','), '');
            insertUrlParameters(UrlParams);
        });
    }


    // initialize noUiSlider price slider
    let $priceSlider = document.getElementById('price-slider');
    if ($priceSlider) {
        noUiSlider.create($priceSlider, {
            start: [filterMinPrice, filterMaxPrice],
            step: 10,
            connect: true,
            tooltips: [true, true],
            range: {
                'min': globalMinPrice,
                'max': globalMaxPrice
            }
        });
        $priceSlider.noUiSlider.on('end', function () {
            let UrlParams = rebuildUrlParameters('price', $priceSlider.noUiSlider.get(), '');
            insertUrlParameters(UrlParams);
        });
    }


    let $productSearch = $(".header-section .product-search").autocomplete({
        minLength: 2,
        position: {
            my: "left top",
            at: "left-1 top+34"
        },
        source: 'ajax/search-products',
        focus: function () {
            return false;
        },
        open: function () {
            var searchWidth = $('.header-search .form-group').width();
            $('.header-search .form-group').addClass('open');
            $('.ui-autocomplete').width(searchWidth);
        },
        select: function (event, ui) {
            window.location = ui.item.url;
            return false;
        }
    });

    $productSearch.each(function () {
        $(this).autocomplete("instance")._renderItem = function (ul, item) {

            if (item.thumb !== false) {
                return $('<li>')
                    .append(
                        '<div>' +
                        '<img src="' + item.thumb + '">' +
                        '<strong>' + item.label + '</strong><br>' +
                        item.description +
                        '</div>'
                    )
                    .appendTo(ul);

            } else {
                return $('<li>')
                    .append(
                        '<div>' +
                        '<strong>' + item.label + '</strong><br>' +
                        item.description +
                        '</div>'
                    )
                    .appendTo(ul);
            }
        };
    });

    let $mobileSearch = $(".mobile-menu .product-search").autocomplete({
        minLength: 2,
        position: {
            my: "left top",
            at: "left-1 top+34"
        },
        source: 'ajax/search-products',
        focus: function () {
            return false;
        },
        select: function (event, ui) {
            window.location = ui.item.url;
            return false;
        }
    });

    $mobileSearch.each(function () {
        $(this).autocomplete("instance")._renderItem = function (ul, item) {
            return $('<li>')
                .append(
                    '<div>' +
                    '<img src="' + item.thumb + '">' +
                    '<strong>' + item.label + '</strong><br>' +
                    item.description +
                    '</div>'
                )
                .appendTo(ul);
        };
    });

});

function addGiveAwayToCart(productId, add)
{
    disableCart();

    $.ajax({
        url: 'ajax/cart-add-give-away',
        data: {'product':productId, 'add':add},
        success: function (feedback) {

            if (feedback.hasOwnProperty('success') && feedback.success) {
            } else {
                alert("ERROR: cannot add giveaway");
            }
            enableCart();
        }
    });
}

function addServiceToCart(serviceId, add, customerMessage)
{
    disableCart();

    $.ajax({
        url: 'ajax/cart-add-service',
        data: {'service':serviceId, 'add':add, 'customerMessage':customerMessage},
        success: function (feedback) {

            if (feedback.hasOwnProperty('success') && feedback.success) {
            } else {
                alert("ERROR: cannot add service");
            }
            enableCart();
        }
    });
}

function addProductToCart(productId, quantity, btn, reload, sizeId, discountCode) {
    btn.blur();
    disableButton(btn);

    $.ajax({
        url: 'ajax/cart-add-product',
        data: {'product':productId, 'quantity':quantity, 'size': sizeId, 'discountCode': discountCode},
        success: function (feedback) {

            if (feedback.hasOwnProperty('success') && feedback.success) {
                enableButton(btn);

                $('html, body').animate({scrollTop: 0}, 300);

                MINI_CART_ITEMS.html(feedback.items);

                if (feedback.hasOwnProperty('row')) {
                    MINI_CART_PANEL.find(".cart-panel-rows").html('').append(feedback.row);
                    $('body').addClass('body_cart_open');
                    MINI_CART_PANEL.show();

                    closeMiniCart();
                }

                if (reload===1) {
                    window.setTimeout(function () {
                        location.reload();
                    },500);
                }

                // Run the second AJAX call after the first one has successfully completed
                $.ajax({
                    url: 'ajax/cart-cookie',
                    success: function (cookieFeedback) {
                        // Do nothing
                    }
                });

            } else {
                alert("Kan het product niet toevoegen aan de winkelwagen. "+feedback.message);
            }

        }
    });

}

function updateMiniCart()
{
    $.ajax({
        url: 'ajax/cart-fetch-mini',
        success: function (feedback) {

            // update mini-cart
            if (feedback.hasOwnProperty('items')) {
                MINI_CART_ITEMS.html(feedback.items);
            } else {
                alert("ERROR: cannot update cart");
            }

        }
    });
}

/**
 * bind actions to close cart popout
 */
function closeMiniCart() {
    $('.body_cart_open').on('click', 'div:not(.panel-body)', function (e) {
        $('body').removeClass('body_cart_open');
        $('.cart-panel').hide();
    });
    $('.cart-close').on('click', function (e) {
        e.preventDefault();
        $('body').removeClass('body_cart_open');
        $('.cart-panel').hide();
    });
}

/**
 * rebuild url parameters
 *
 * @param key
 * @param value
 * @param url
 * @returns {string}
 */
function rebuildUrlParameters(key, value, url) {
    key = (key);
    value = (value);

    if (url === '') {
        url = document.location.search.substr(1);
    }

    if (url === '') {
        return '?' + key + '=' + value;
    } else {

        let kvp = url.split('&');

        let i = kvp.length;
        let x;
        while (i--) {
            x = kvp[i].split('=');

            if (x[0] === key) {
                x[1] = value;
                kvp[i] = x.join('=');
                break;
            }
        }

        if (i < 0) {
            kvp[kvp.length] = [key, value].join('=');
        }

        return kvp.join('&');
    }
}

/**
 * insert url parameters to current url (releoad)
 *
 * @param kvp
 */
function insertUrlParameters(kvp) {
    document.location.search = kvp;
}

/**
 * disable form button
 *
 * @param button
 */
function disableButton(button) {
    button.addClass('disabled');
    button.prop('disabled', true);
}

/**
 * enable form button
 *
 * @param button
 */
function enableButton(button) {
    button.removeClass('disabled');
    button.prop('disabled', false);
}

function disableCart() {
    $(".cart-overlay").toggle();
}

function enableCart() {
    $(".cart-overlay").toggle();
}
